import FwPlugins from './models/messages';
import {
  isCalledByParent, getCallerParentId, isPresentIFrame, getCallerParams, getCallerExtraParams,
} from './models/caller';
import { callParent, callChild } from './models/forward';
import { PluginMessageTypes } from './models/constants';
import { eventFilter, functFilter } from './models/clickOut';

// componenti per parent
export { default as IFrame } from './components/parent/IFrame';
export { default as ModalIFrame } from './components/parent/ModalIFrame';
export { default as DrawerIFrame } from './components/parent/DrawerIFrame';
// componenti per children
export { default as PluginApp } from './components/children/PluginApp/PluginApp';
export { default as PluginRouter } from './components/children/PluginRouter/PluginRouter';
// hooks
export { default as usePluginReducer } from './hooks/usePluginReducer';
export { default as usePluginAppChild } from './hooks/usePluginAppChild';
export { default as usePluginAppViewport } from './hooks/usePluginAppViewport';

FwPlugins.isCalledByParent = isCalledByParent;
FwPlugins.getCallerParentId = getCallerParentId;
FwPlugins.callParent = callParent;
FwPlugins.callChild = callChild;
FwPlugins.PluginMessageTypes = PluginMessageTypes;
FwPlugins.getCallerParams = getCallerParams;
FwPlugins.getCallerExtraParams = getCallerExtraParams;
FwPlugins.clickOutEventFilter = eventFilter;
FwPlugins.clickOutFunctionFilter = functFilter;
FwPlugins.isPresentIFrame = isPresentIFrame;

export default FwPlugins;
